<script lang="ts">
    import PageLayout from "$lib/components/PageLayout.svelte";
    import {Card} from "flowbite-svelte";
    import {
        AtomOutline,
        CashSolid,
        ClipboardListSolid, EnvelopeSolid,
        FileCodeSolid, GiftBoxSolid,
        IconSolid,
        UserEditSolid,
        UserSettingsSolid, UsersGroupSolid
    } from "flowbite-svelte-icons";
    import {user} from "$lib/stores/auth";
    import {browser} from "$app/environment";

    let isAdmin = false;
    if (browser) {
        user.subscribe(x => {
            if (typeof x !== 'undefined') {
                isAdmin = x.administrator
            }
        })
    }

    $: cards = [
        {
            title: "Profil Einstellungen",
            icon: UserSettingsSolid,
            show: true,
            href: '/settings/profile'
        }, {
            title: "Zugriffseinstellungen",
            icon: UserEditSolid,
            href: '/settings/access',
            show: isAdmin,
        }, {
            title: "Vorlagen",
            icon: FileCodeSolid,
            href: '/settings/templates',
            show: isAdmin,
        }, {
            title: "Kostenstellen",
            icon: ClipboardListSolid,
            href: '/settings/cost-center',
            show: isAdmin,
        },{
            title: "Units",
            icon: AtomOutline,
            href: '/settings/units',
            show: isAdmin,
        }, {
            title: "Tarife",
            icon: CashSolid,
            href: '/settings/tariffs',
            show: isAdmin,
        }, {
            title: "Batch-Operationen",
            icon: UsersGroupSolid,
            href: '/settings/batch',
            show: isAdmin,
        }, {
            title: "Mailing",
            icon: EnvelopeSolid,
            href: '/settings/mailing',
            show: isAdmin,
        }, {
            title: "UI",
            icon: GiftBoxSolid,
            href: '/ui',
            show: isAdmin,
        }
    ];

</script>
<svelte:head>
    <title>Settings</title>
</svelte:head>

<div class="flex flex-wrap gap-3">
    {#each cards as card}
        {#if card.show}
            <Card class="w-64" href={card.href}>
                <IconSolid class="w-8 h-8" icon="{card.icon}"/>
                <h3>{card.title}</h3>
            </Card>
        {/if}
    {/each}
</div>